import React, { useState, useContext } from 'react';
import { LanguageContext } from '../../../App';
import { Modal } from '../../ui/Modal';
import { BellIcon, ChevronDownIcon } from 'lucide-react';
interface BroadcastModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const BroadcastModal: React.FC<BroadcastModalProps> = ({
  isOpen,
  onClose
}) => {
  const {
    language
  } = useContext(LanguageContext);
  const [broadcastType, setBroadcastType] = useState('all');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle broadcast submission
    // In a real app, this would send data to an API
    // Close the modal after submission
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title={language === 'en' ? 'Send Broadcast' : 'إرسال تعميم'} size="md" data-id="element-474">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-475">
        {/* Broadcast Type */}
        <div data-id="element-476">
          <label htmlFor="broadcastType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-477">
            {language === 'en' ? 'Broadcast To' : 'إرسال إلى'}
          </label>
          <div className="relative" data-id="element-478">
            <select id="broadcastType" value={broadcastType} onChange={e => setBroadcastType(e.target.value)} className="appearance-none block w-full px-10 py-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" data-id="element-479">
              <option value="all" data-id="element-480">
                {language === 'en' ? 'All Drivers' : 'جميع السائقين'}
              </option>
              <option value="active" data-id="element-481">
                {language === 'en' ? 'Active Drivers Only' : 'السائقين النشطين فقط'}
              </option>
              <option value="area" data-id="element-482">
                {language === 'en' ? 'Drivers in Specific Area' : 'السائقين في منطقة محددة'}
              </option>
            </select>
            <BellIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-483" />
            <ChevronDownIcon size={16} className="absolute right-3 top-3 text-gray-400" data-id="element-484" />
          </div>
        </div>
        {/* Area Selection (conditional) */}
        {broadcastType === 'area' && <div data-id="element-485">
            <label htmlFor="area" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-486">
              {language === 'en' ? 'Select Area' : 'اختر المنطقة'}
            </label>
            <div className="relative" data-id="element-487">
              <select id="area" className="appearance-none block w-full px-4 py-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" data-id="element-488">
                <option value="kuwait-city" data-id="element-489">
                  {language === 'en' ? 'Kuwait City' : 'مدينة الكويت'}
                </option>
                <option value="salmiya" data-id="element-490">
                  {language === 'en' ? 'Salmiya' : 'السالمية'}
                </option>
                <option value="hawally" data-id="element-491">
                  {language === 'en' ? 'Hawally' : 'حولي'}
                </option>
                <option value="jabriya" data-id="element-492">
                  {language === 'en' ? 'Jabriya' : 'الجابرية'}
                </option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-3 top-3 text-gray-400" data-id="element-493" />
            </div>
          </div>}
        {/* Broadcast Title */}
        <div data-id="element-494">
          <label htmlFor="broadcastTitle" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-495">
            {language === 'en' ? 'Broadcast Title' : 'عنوان التعميم'}
          </label>
          <input type="text" id="broadcastTitle" className="block w-full px-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" placeholder={language === 'en' ? 'Enter title' : 'أدخل العنوان'} required data-id="element-496" />
        </div>
        {/* Broadcast Message */}
        <div data-id="element-497">
          <label htmlFor="broadcastMessage" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-498">
            {language === 'en' ? 'Message' : 'الرسالة'}
          </label>
          <textarea id="broadcastMessage" rows={4} className="block w-full px-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" placeholder={language === 'en' ? 'Enter broadcast message' : 'أدخل نص التعميم'} required data-id="element-499"></textarea>
        </div>
        {/* Urgency Level */}
        <div data-id="element-500">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-501">
            {language === 'en' ? 'Urgency Level' : 'مستوى الأهمية'}
          </label>
          <div className="flex space-x-4" data-id="element-502">
            <div className="flex items-center" data-id="element-503">
              <input id="urgency-low" name="urgency" type="radio" value="low" className="h-4 w-4 text-congress-blue-600 focus:ring-congress-blue-500 border-gray-300" data-id="element-504" />
              <label htmlFor="urgency-low" className="ml-2 block text-sm text-gray-700" data-id="element-505">
                {language === 'en' ? 'Low' : 'منخفض'}
              </label>
            </div>
            <div className="flex items-center" data-id="element-506">
              <input id="urgency-medium" name="urgency" type="radio" value="medium" className="h-4 w-4 text-congress-blue-600 focus:ring-congress-blue-500 border-gray-300" defaultChecked data-id="element-507" />
              <label htmlFor="urgency-medium" className="ml-2 block text-sm text-gray-700" data-id="element-508">
                {language === 'en' ? 'Medium' : 'متوسط'}
              </label>
            </div>
            <div className="flex items-center" data-id="element-509">
              <input id="urgency-high" name="urgency" type="radio" value="high" className="h-4 w-4 text-congress-blue-600 focus:ring-congress-blue-500 border-gray-300" data-id="element-510" />
              <label htmlFor="urgency-high" className="ml-2 block text-sm text-gray-700" data-id="element-511">
                {language === 'en' ? 'High' : 'عالي'}
              </label>
            </div>
          </div>
        </div>
        {/* Action Buttons */}
        <div className="flex justify-end space-x-3" data-id="element-512">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-513">
            {language === 'en' ? 'Cancel' : 'إلغاء'}
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-congress-blue-600 hover:bg-congress-blue-700" data-id="element-514">
            {language === 'en' ? 'Send Broadcast' : 'إرسال التعميم'}
          </button>
        </div>
      </form>
    </Modal>;
};